/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import {
  IAttributeListRequest,
  IAttributeListResponse,
  IMapToUuidRequest,
  IMapToUuidResponse,
  ISearchAssignmentsRequest,
  ISearchAssignmentsResponse
} from '../../models';
import { IAttributeHttpService } from './attribute-http.service.interface';

@Injectable()
export class AttributeHttpService implements IAttributeHttpService {
  private readonly _rootUrl: string;

  constructor(private readonly _httpClient: HttpClient) {
    this._rootUrl = `${environment.config.endpoints.attributeApiEndpoint}/v1`;
  }

  getAttributes(params?: IAttributeListRequest): Observable<IAttributeListResponse> {
    let httpParams = new HttpParams();

    if (params?.search) {
      httpParams = httpParams.set('Search', params.search);
    }
    if (params?.limit != null) {
      httpParams = httpParams.set('Limit', params.limit);
    }
    if (params?.offset != null) {
      httpParams = httpParams.set('Offset', params.offset);
    }
    if (params?.totalRequired != null) {
      httpParams = httpParams.set('TotalRequired', params.totalRequired);
    }

    return this._httpClient.get<IAttributeListResponse>(`${this._rootUrl}/attributes`, { params: httpParams });
  }

  mapToUuid(body: IMapToUuidRequest): Observable<IMapToUuidResponse> {
    return this._httpClient.post<IMapToUuidResponse>(`${this._rootUrl}/mappings/map-to-uuid`, body);
  }

  searchAssignments(body: ISearchAssignmentsRequest): Observable<ISearchAssignmentsResponse> {
    return this._httpClient.post<ISearchAssignmentsResponse>(`${this._rootUrl}/assignments/search`, body);
  }
}
